export function transitionend(element: HTMLElement, expectImmediate?: boolean, propertyName?: string, handler?: Function): Promise<void>;
export function transitionend(element: HTMLElement, expectImmediate?: boolean, handler?: Function): Promise<void>;
export function transitionend(element: HTMLElement, propertyName?: string, handler?: Function): Promise<void>;
export function transitionend(element: HTMLElement, handler?: Function): Promise<void>;
export function transitionend(): Promise<void> {
  let i = 0;
  let element: HTMLElement = arguments[i++];
  let expectImmediate: boolean = typeof(arguments[i]) === 'boolean' ? arguments[i++] : true;
  let propertyName: string = typeof(arguments[i]) === 'string' ? arguments[i++] : undefined;
  let handler: (value: void) => void = typeof(arguments[i]) === 'function' ? arguments[i++] : undefined;
  let transitionendEvents = ['transitionend', 'webkitTransitionEnd', 'oTransitionEnd', 'otransitionend', 'MSTransitionEnd'];
  let timeout: number;

  let promise: Promise<void> = new Promise((resolve, reject) => {
    // Wait for transition-end event
    let check = (e?: TransitionEvent) => {
      if (e && propertyName && e.propertyName !== propertyName) {
        return;
      }
      for (let i=0; i<transitionendEvents.length; i++) {
        let eventName = transitionendEvents[i];
        element.removeEventListener(eventName, check);
      }
      if (timeout) {
        clearTimeout(timeout);
      }
      resolve();
    };

    for (let i=0; i<transitionendEvents.length; i++) {
      let eventName = transitionendEvents[i];
      element.addEventListener(eventName, check);
    }

    if (expectImmediate) {
      timeout = window.setTimeout(check, transitionDuration(element, propertyName));
    }
  });

  if (handler) {
    promise.then(() => {
      handler.call(element);
    });
  } else {
    return promise;
  }
}


function getPropertyAsArray(style: CSSStyleDeclaration, properties: string[]) {
  // We're looping through the same property but with browser prefixes. We can return on the first find
  for (let i=0; i<properties.length; i++) {
    let cssvalue: string = style[properties[i]];
    if (typeof(cssvalue) !== 'undefined') {
      return cssvalue.trim().split(/\s*,\s/);
    }
  }
  return [];
}

export function transitionDuration(element: HTMLElement, propertyName?: string) {
  // Detect transition duration
  let transitionPropertyNames = ['transitionProperty', 'webkitTransitionProperty', 'msTransitionProperty', 'MozTransitionProperty', 'OTransitionProperty'];
  let transitionDurationNames = ['transitionDuration', 'webkitTransitionDuration', 'msTransitionDuration', 'MozTransitionDuration', 'OTransitionDuration'];
  let transitionDelayNames = ['transitionDelay', 'webkitTransitionDelay', 'msTransitionDelay', 'MozTransitionDelay', 'OTransitionDelay'];

  // Get list of durations, one duration for each property
  let style = window.getComputedStyle(element);
  let durations = getPropertyAsArray(style, transitionDurationNames);
  let delays = getPropertyAsArray(style, transitionDelayNames);
  let propertyIndex = 0;

  if (propertyName) {
    let propertyNames = getPropertyAsArray(style, transitionPropertyNames);
    propertyIndex = propertyNames.indexOf(propertyName);
    if (propertyIndex < 0) { // The best way to fail is to use the first available property, possibly 'all'
      propertyIndex = 0;
    }
  }

  let delayString = delays[propertyIndex];
  let delay = 0;
  if (delayString) {
    if (delayString.indexOf('ms') >= 0 ) { // 1ms
      delay = parseFloat(delayString);
    } else { // 1s
      delay = parseFloat(delayString) * 1000;
    }
    if (isNaN(delay)) {
      delay = 0;
    }
  }

  let durationString = durations[propertyIndex];
  let duration = 0;
  if (durationString) {
    if (durationString.indexOf('ms') >= 0) { // 1ms
      duration = parseFloat(durationString);
    } else {
      duration = parseFloat(durationString) * 1000;
    }
    if (isNaN(duration)) {
      duration = 0;
    }
  }

  return delay + duration;
};
